export default __webpack_public_path__ + "static/media/blogHeaderImage.caee9470.png";